import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import { RequiredMessagePara } from "@utils/extra-style";
import { GridRow, GridItem, MarginDiv } from "../../AddEditSupplier.styled";
import PlanningSolution from "./PlanningSolution";
import Haulage from "./Haulage.jsx";
import MarginSection from "./MarginSection.jsx";

const SupplierItems = (props) => {
  const {
    t,
    isEdit,
    quoteCurrency,
    exchangeRates,
    formData,
    onChange,
    transportTypes,
    platformCountryId,
    multiCurrencyObject,
  } = props;

  return (
    <>
      {formData?.services[0]?.serviceItems?.map((item, itemIndex) => {
        return (
          <MarginDiv key={"supplier-planning-serviceitems-" + itemIndex}>
            {item?.hesusService?.needSupplierPlanning && (
              <>
                <GridRow
                  column="50% 15% 35%"
                  marginTop="0px"
                  marginBottom="0px"
                  gap="0rem"
                >
                  <GridItem
                    fontSize="16px"
                    fontWeight="700"
                    color="#fff"
                    backgroundColor="#008395"
                    padding="5px 10px"
                    textAlign="left"
                    gap="0rem"
                    leftRadius="5px"
                    rightRadius="0px"
                  >
                    {item?.hesusService?.name}
                  </GridItem>
                  <GridItem
                    fontSize="16px"
                    fontWeight="700"
                    borderRight="1px solid #fff"
                    color="#fff"
                    backgroundColor="#008395"
                    padding="5px 10px"
                    textAlign="right"
                    gap="0rem"
                    leftRadius="0px"
                    rightRadius="0px"
                  >
                    {renderPriceWithCurrency(
                      addSpace(
                        getConvertedPrice(
                          formData?.services[0]?.currency?.id,
                          item?.itemInfo?.sellingPrice,
                          exchangeRates
                        )
                      ),
                      t(item?.itemInfo?.unit),
                      quoteCurrency?.symbol,
                      quoteCurrency?.position
                    )}
                  </GridItem>
                  <GridItem
                    fontSize="16px"
                    fontWeight="700"
                    borderRight="0px solid #fff"
                    color="#fff"
                    backgroundColor="#008395"
                    padding="5px 10px"
                    textAlign="center"
                    gap="0rem"
                    leftRadius="0px"
                    rightRadius="5px"
                  >
                    {/* {t("SUPPLIERS_PLANNING_LEFT_TO_PLAN") +
                      " : " +
                      item?.itemInfo?.clientOrderItem?.quantity}{" "}
                    {t(item?.itemInfo?.clientOrderItem?.unit)} */}
                  </GridItem>
                </GridRow>
                {((!item?.hesusService?.needCombination &&
                  item?.hesusService?.needCenter &&
                  item?.hesusService?.needCarrier) ||
                  (!item?.hesusService?.needCombination &&
                    item?.hesusService?.needCenter &&
                    !item?.hesusService?.needCarrier) ||
                  (item?.hesusService?.needCombination &&
                    item?.hesusService?.needCenter &&
                    !item?.hesusService?.needCarrier)) && (
                  <GridRow
                    column="65% 35%"
                    marginTop="0px"
                    marginBottom="0px"
                    gap="0rem"
                    borderRight="2px solid #767676"
                    borderLeft="2px solid #767676"
                  >
                    <GridRow borderBottom="2px solid #767676">
                      <PlanningSolution
                        item={item}
                        itemIndex={itemIndex}
                        koMarginRate={item?.itemInfo?.koMarginRate}
                        onChange={onChange}
                      />
                      {item?.solutionId?.error !== "" && (
                        <GridRow column="1fr">
                          <GridItem textAlign="left" padding="5px 10px">
                            <RequiredMessagePara
                              fontStyle="italic"
                              maxWidth="auto"
                            >
                              {item.solutionId.error}
                            </RequiredMessagePara>
                          </GridItem>
                        </GridRow>
                      )}
                    </GridRow>

                    <GridItem
                      fontSize="16px"
                      fontWeight="700"
                      color="#fff"
                      padding="5px 10px"
                      textAlign="left"
                      gap="0rem"
                      leftRadius="0px"
                      rightRadius="0px"
                      borderLeft="1px solid #008395"
                      borderBottom={
                        item?.hesusService?.needCombination &&
                        item?.hesusService?.needCenter &&
                        !item?.hesusService?.needCarrier
                          ? "2px solid #767676"
                          : "0px solid #767676"
                      }
                    >
                      <MarginSection
                        item={item}
                        itemIndex={itemIndex}
                        isEdit={isEdit}
                        onChange={onChange}
                      />
                    </GridItem>
                  </GridRow>
                )}
                {((!item?.hesusService?.needCombination &&
                  item?.hesusService?.needCenter &&
                  item?.hesusService?.needCarrier) ||
                  (!item?.hesusService?.needCombination &&
                    !item?.hesusService?.needCenter &&
                    item?.hesusService?.needCarrier) ||
                  (item?.hesusService?.needCombination &&
                    !item?.hesusService?.needCenter &&
                    item?.hesusService?.needCarrier)) && (
                  <GridRow
                    column="65% 35%"
                    marginTop="0px"
                    marginBottom="0px"
                    gap="0rem"
                    borderRight="2px solid #767676"
                    borderLeft="2px solid #767676"
                    borderBottom="2px solid #767676"
                  >
                    <GridRow padding="10px" borderTop="0px solid #767676">
                      <Haulage
                        item={item}
                        isEdit={isEdit}
                        transportTypes={transportTypes}
                        onChange={onChange}
                        itemIndex={itemIndex}
                        platformCountryId={platformCountryId}
                        multiCurrencyObject={multiCurrencyObject}
                      />
                    </GridRow>

                    <GridItem
                      fontSize="16px"
                      fontWeight="700"
                      color="#fff"
                      padding="5px 10px"
                      textAlign="left"
                      gap="0rem"
                      leftRadius="0px"
                      rightRadius="0px"
                      borderLeft="1px solid #008395"
                    >
                      {((!item?.hesusService?.needCombination &&
                        !item?.hesusService?.needCenter &&
                        item?.hesusService?.needCarrier) ||
                        (item?.hesusService?.needCombination &&
                          !item?.hesusService?.needCenter &&
                          item?.hesusService?.needCarrier)) && (
                        <MarginSection
                          item={item}
                          itemIndex={itemIndex}
                          isEdit={isEdit}
                          onChange={onChange}
                        />
                      )}
                    </GridItem>
                  </GridRow>
                )}
                {!item?.hesusService?.needCombination &&
                  item?.hesusService?.needCenter &&
                  !item?.hesusService?.needCarrier && (
                    <GridRow
                      column="65% 35%"
                      marginTop="0px"
                      marginBottom="0px"
                      gap="0rem"
                      borderRight="2px solid #767676"
                      borderLeft="2px solid #767676"
                      borderBottom="2px solid #767676"
                    >
                      <GridRow padding="10px" borderTop="0px solid #767676">
                        <Haulage
                          onlyTranport
                          item={item}
                          isEdit={isEdit}
                          transportTypes={transportTypes}
                          onChange={onChange}
                          itemIndex={itemIndex}
                          platformCountryId={platformCountryId}
                          multiCurrencyObject={multiCurrencyObject}
                        />
                      </GridRow>
                      <GridItem
                        fontSize="16px"
                        fontWeight="700"
                        color="#fff"
                        padding="5px 10px"
                        textAlign="left"
                        gap="0rem"
                        leftRadius="0px"
                        rightRadius="0px"
                        borderLeft="1px solid #008395"
                      >
                        {" "}
                      </GridItem>
                    </GridRow>
                  )}
              </>
            )}
          </MarginDiv>
        );
      })}
    </>
  );
};
SupplierItems.propTypes = {
  t: PropTypes.func.isRequired,
  isEdit: PropTypes.string,
};

SupplierItems.defaultProps = {
  isEdit: false,
};
export default withTranslation()(SupplierItems);
